module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"on":"am"},"en":{"on":"on"}}')
  delete Component.options._Ctor
}
